import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CodigosServicoComponent } from './codigos-servico.component';

const routes: Routes = [
  {
    path: '',
    component: CodigosServicoComponent,
    title: 'Códigos de Serviço e Tributação',
    children: [{ path: ':mode', redirectTo: '', pathMatch: 'full' }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CodigosServicoRoutingModule { }
